import moment from 'moment';

export const timeFormat = (time?: string) => {
  if (!time) {
    return '';
  }
  const date = moment(time);
  const startOfDay = moment().startOf('day');
  if (date > startOfDay) {
    return date?.format('h:mm a');
  } else {
    return date?.format('MM/DD/YYYY');
  }
};

export const dateFormat = (time: string) => {
  return moment(new Date(time)).format('YYYY-MM-DD HH:mm');
};
